import onboardingCopyJson from '../../guidance/chat/onboarding.json'
import type { OnboardingCopy } from '../../../netlify/functions/lib/project-chat-types'

/**
 * All onboarding copy: src/guidance/chat/onboarding.json, imported at build time (no request, so
 * OnboardingChat renders without waiting on a Lambda).
 */
export const ONBOARDING_COPY = onboardingCopyJson as OnboardingCopy
